import { useEffect, useState } from "react";
import { Alert, Form, Modal } from "react-bootstrap";

import DstButton from "../../../../../components/DstButton/DstButton";
import RequiredLabel from "../../../../../components/RequiredLabel/RequiredLabel";
import translate from "../../../../../services/Translate";
import { updateExerciseResources } from "./EditExerciseResourcesModal.function";

const EditExerciseResourcesModal = ({ show, onClose, exercise, language, onSuccess }: any) => {
  const [isEditing, setIsEditing] = useState(false);

  const [form, setForm] = useState({
    cpu: 0,
    memory: 0,
    ephemeral_storage: 0,
  });

  useEffect(() => {
    setForm({
      cpu: exercise.required_resources?.cpu ?? 0,
      memory: exercise.required_resources?.memory ?? 0,
      ephemeral_storage: exercise.required_resources?.ephemeral_storage ?? 0,
    });
  }, [exercise, onClose]);

  const _handleChange = (key: string, value: any) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const _handleSubmit = () => {
    updateExerciseResources(
      exercise.id,
      form,
      setIsEditing,
      () => {
        onSuccess?.();
        onClose?.();
      },
      language
    );
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.RESOURCES.TITLE")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert variant="warning">
          <span className="dst-icon-alert-triangle me-2" />
          {translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.RESOURCES.MAX_VALUES_WARNING")}
        </Alert>
        <Form>
          <Form.Group className="mb-3">
            <RequiredLabel label={translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.RESOURCES.FIELDS.CPU")} />
            <Form.Control
              type="number"
              min={0}
              value={form.cpu}
              onChange={(event) => _handleChange("cpu", Number(event.target.value))}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <RequiredLabel label={translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.RESOURCES.FIELDS.MEMORY")} />
            <Form.Control
              type="number"
              min={0}
              value={form.memory}
              onChange={(event) => _handleChange("memory", Number(event.target.value))}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <RequiredLabel label={translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.RESOURCES.FIELDS.STORAGE")} />
            <Form.Control
              type="number"
              min={0}
              value={form.ephemeral_storage}
              onChange={(event) => _handleChange("ephemeral_storage", Number(event.target.value))}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <DstButton variant="secondary" value={translate(language, "GLOBAL.CANCEL")} clickFunction={onClose} />
        <DstButton
          loading={isEditing}
          value={translate(language, "GLOBAL.SAVE")}
          clickFunction={_handleSubmit}
          disabled={isEditing}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default EditExerciseResourcesModal;
